import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: (siteId?: string) =>
    fetchPages<ManifestationResponse>(
      'manifestations',
      `${config.ws.manifestation.all}${siteId ? `?siteId=${siteId}` : ''}`,
      'GET'
    ),
  get: (siteId: string, id: string) =>
    ws<ManifestationDetailResponse>(config.ws.manifestation.get.replace('{id}', id) + `?siteId=${siteId}`, 'GET'),
}

export default api
